var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.creator)?_c('div',{staticClass:"featured-creator d-flex flex-column justify-center align-center"},[_c('Avatar',{attrs:{"size":70,"did":_vm.creator.did,"hash":_vm.creator.profilePhoto,"imgType":"bigv","grade":_vm.creator.grade}}),_c('div',{staticClass:"name mt-lg-2"},[_vm._v(_vm._s(_vm.username))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }